module.exports = __webpack_public_path__ + "img/a7.3d2252f2.svg";